import Countdown from 'react-countdown-now';

export default class CountdownTimer extends Countdown {
	componentWillReceiveProps(nextProps) {
		super.componentWillReceiveProps(nextProps);
		// Required for reset
		if (!this.props.controlled) {
			this.interval = setInterval(this.tick, this.props.intervalDelay);
		}
	}
}


// WEBPACK FOOTER //
// ./components/countdown/CountdownTimer.js